import React, { useState, useEffect, useRef, useCallback } from "react";
import PropTypes from "prop-types";

// Debounce delay in milliseconds
const DEBOUNCE_DELAY = 300;

export const ColumnFilter = ({ column }) => {
  const { filterValue, setFilter } = column;
  const [localValue, setLocalValue] = useState(filterValue || "");
  const debounceRef = useRef(null);

  useEffect(() => {
    setLocalValue(filterValue || "");
  }, [filterValue]);

  // Debounced filter update
  const debouncedSetFilter = useCallback(
    (value) => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
      debounceRef.current = setTimeout(() => {
        setFilter(value || undefined);
      }, DEBOUNCE_DELAY);
    },
    [setFilter]
  );

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);

  const handleChange = (e) => {
    const value = e.target.value;
    setLocalValue(value);
    debouncedSetFilter(value);
  };

  return (
    <span>
      <input
        style={{ width: "75%" }}
        value={localValue}
        onChange={handleChange}
      />
    </span>
  );
};

ColumnFilter.propTypes = {
  column: PropTypes.shape({
    filterValue: PropTypes.string,
    setFilter: PropTypes.func.isRequired,
  }).isRequired,
};

// Custom "starts with" filter function for react-table
export const startsWithFilter = (rows, id, filterValue) => {
  if (!filterValue) return rows;

  const filterLower = filterValue.toLowerCase();
  return rows.filter((row) => {
    const rowValue = row.values[id];
    if (rowValue === undefined || rowValue === null) return false;
    return String(rowValue).toLowerCase().startsWith(filterLower);
  });
};

// Set the filter type for autoRemove behavior
startsWithFilter.autoRemove = (val) => !val;
